<template>
  <v-container>
    <v-select
          :items="intelLevels"
          v-model="selectedIntel"
          :rules="[v => !!v || $t('intel_eval_required')]"
          solo
        ></v-select>
    <v-row>
      <v-col>
        <p><span class="font-weight-bold">1:</span> {{ $t('intelligence_evaluation_1') }}</p>
        <p><span class="font-weight-bold">2:</span> {{ $t('intelligence_evaluation_2') }}</p>
        <p><span class="font-weight-bold">3:</span> {{ $t('intelligence_evaluation_3') }}</p>
        <p><span class="font-weight-bold">4:</span> {{ $t('intelligence_evaluation_4') }}</p>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { maocData } from '../../services/MaocData'

export default {
  name: 'IntelEvaluation',
  data: vm => ({
    selectedIntel: '',
    intelLevels: maocData.intelEvaluation
  }),
  methods: {
    getData: function () {
      return this.selectedIntel
    },
    setData: function (data) {
      this.selectedIntel = data
    }
  }
}
</script>
